import DragIndicatorRoundedIcon from '@mui/icons-material/DragIndicatorRounded';

export default DragIndicatorRoundedIcon;
